import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter, Subscription } from 'rxjs';
import {ISummaryItem} from '@components/ui/summary-items-list/summary-items-list';
import {ThemeModule} from '@app/themes/theme-module';

@Component({
  selector: 'app-crop-monitoring-administration-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, ThemeModule],
  templateUrl: './crop-monitoring-administration-menu.component.html',
  styleUrls: ['./crop-monitoring-administration-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CropMonitoringAdministrationMenuComponent implements OnInit, OnDestroy {
  items: ISummaryItem[] = [];
  showMenu = true;
  private routerSubscription!: Subscription;

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private location: Location,
  ) {}

  ngOnInit(): void {
    this.items = [
      {
        icon: 'assets/icons/main/light/task-ead-icon.svg',
        iconBack: 'assets/icons/main/light/task-icon-line-chart-fill.svg',
        title: 'Task Scheduler',
        url: '/crop-monitoring/administration/scheduler',
        cardStyle: { background: '#6DDE89' },
      },
      {
        icon: 'assets/icons/main/light/licon-ead-icon.svg',
        iconBack: 'assets/icons/main/light/user-icon-line-chart-fill.svg',
        title: 'Logging',
        url: '/crop-monitoring/administration/logging',
        cardStyle: { background: '#B48EFFCC' },
      },
    ];

    this.checkRoute();

    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkRoute();
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  goBack(): void {
    this.location.back();
  }

  private checkRoute(): void {
    const isRoot = this.router.url.split('?')[0] === '/crop-monitoring/administration';

    if (this.showMenu !== isRoot) {
      this.showMenu = isRoot;
      this.cdr.markForCheck();
    }
  }
}
